import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  LayoutGrid,
  Sparkles,
  Code2,
  BarChart3,
  Workflow,
  Network,
  ArrowUpRight,
} from 'lucide-react';
import { Container, Reveal, SectionLabel } from './primitives';
import { SERVICE_CARDS } from './constants';
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';

const ICONS = { LayoutGrid, Sparkles, Code2, BarChart3, Workflow, Network };

export default function Services() {
  const { t } = useTranslation();
  const { events: gaEvents } = useGoogleAnalytics();

  return (
    <section id="services" className="bg-ink py-20 sm:py-28">
      <Container>
        <Reveal className="max-w-2xl">
          <SectionLabel>{t('home.services.eyebrow')}</SectionLabel>
          <h2 className="mt-5 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {t('home.services.title')}
          </h2>
          {t('home.services.subtitle') && (
            <p className="mt-4 text-lg text-white/55">{t('home.services.subtitle')}</p>
          )}
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICE_CARDS.map((card, i) => {
            const Icon = ICONS[card.icon] || LayoutGrid;
            return (
              <Reveal key={card.id} delay={(i % 3) * 70}>
                <button
                  type="button"
                  onClick={() => gaEvents.viewSolutionCard(card.id)}
                  className="group flex h-full w-full flex-col rounded-2xl border border-line bg-surface p-6 text-left transition-all duration-300 hover:-translate-y-1 hover:border-accent/40 hover:shadow-[0_12px_40px_rgba(109,74,255,0.15)]"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent/15 text-accent-400 transition-colors group-hover:bg-accent-gradient group-hover:text-white">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-5 flex items-center gap-1.5 text-lg font-semibold text-white">
                    {t(`home.services.cards.${card.id}.title`)}
                    <ArrowUpRight className="h-4 w-4 text-white/30 transition-all group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-accent-400" />
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/55">
                    {t(`home.services.cards.${card.id}.description`)}
                  </p>
                  <span className="mt-4 text-xs font-medium uppercase tracking-wide text-accent-400">
                    {t(`home.services.cards.${card.id}.tags`)}
                  </span>
                </button>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
